namespace $.$$ {
	
	$mol_style_define( $hyoo_dnd_char_personality, {
		
		flex: {
			basis: '30rem',
		},
		
	} )
	
}
